import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { UpdatePaymentAccountsService } from "@/features/accounts/payment/scraping/services/update-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext, } from "react";
import { MoneyLinkError, MoneyLinkException, ErrorLevel } from "@/shared/utils/custom-exception";

export const useUpdatePaymentAccounts = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);
  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const updatePaymentAccountsService = new UpdatePaymentAccountsService();

  // 口座更新
  const updatePaymentAccounts = async (
    accountGroupId: string,
    paymentAccountId: string,
    paymentId: string,
    passbookName?: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await updatePaymentAccountsService.updatePaymentAccounts({
        account_group_id: accountGroupId,
        payment_account_id: paymentAccountId,
        payment_id: paymentId,
        ...(passbookName !== "" && { passbook_name: passbookName }),
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("updatePaymentAccounts:", error);
      if (
        error instanceof MoneyLinkException &&
        error.error.props.reason === "webmoneylink_parameter_error"
      ) {
        throw new MoneyLinkException({
          error: new MoneyLinkError({
            level: ErrorLevel.Warn,
            code: error.error.props.code,
            reason: error.error.props.reason,
            messageTitle: undefined,
            messageBody:
              "Web明細帳名に使用できない文字が含まれているか、文字数が上限を超えています。\n入力内容をご確認ください。",
          }),
        });
      }
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    updatePaymentAccounts: errorHandledAsync(updatePaymentAccounts, setError),
  };
};
